import React, { Dispatch, FC, SetStateAction, useContext } from 'react'
import TaskDetail from './TaskDetail'
import { ClickAwayListener } from '@material-ui/core'
import { useScheduler } from '../../context/SchedulerContext'
import { TaskPanelRedirectionParameters } from '../../services/schedule.types'
import { DialogContext } from '../../../../../components/layout/dialog'
import { TYPE_DIALOG } from '../../../../../utils/constants'

type TaskDetailContainerProps = {
	isResultat: boolean
	taskPanelRedirection: TaskPanelRedirectionParameters
	setTaskPanelRedirectionParameters: Dispatch<SetStateAction<TaskPanelRedirectionParameters | undefined>>
}

const TaskDetailContainer: FC<TaskDetailContainerProps> = ({ isResultat, taskPanelRedirection, setTaskPanelRedirectionParameters}) => {
	const { refreshScheduler } = useScheduler()
	const { type: typeDialog } = useContext(DialogContext)

	return <ClickAwayListener mouseEvent="onMouseDown" onClickAway={() => {
		// Dans le cas d'une dialog visible, on ne close pas le panel
		if (typeDialog !== TYPE_DIALOG.ACTION) {
			setTaskPanelRedirectionParameters(undefined)
			if (taskPanelRedirection?.forEdition) {
				refreshScheduler()
			}
		}
	}}>
		<div>
			<TaskDetail
				taskPanelRedirection={taskPanelRedirection}
				isResultat={isResultat}
				closeDetail={() => setTaskPanelRedirectionParameters(undefined)}
			/>
		</div>
	</ClickAwayListener>
}

export default TaskDetailContainer